module.exports = __webpack_public_path__ + "static/media/burj-arab.cb70a100.png";